var IncrementalDOM = require('incremental-dom')
var patch = IncrementalDOM.patch
var elementOpen = IncrementalDOM.elementOpen
var elementClose = IncrementalDOM.elementClose
var skip = IncrementalDOM.skip
var currentElement = IncrementalDOM.currentElement
var text = IncrementalDOM.text

var hoisted1 = ["class", "file-editor"]
var hoisted2 = ["class", "form-group"]
var hoisted3 = ["for", "name"]
var hoisted4 = ["class", "input-group"]
var hoisted5 = ["type", "text", "class", "form-control input-sm", "id", "filename", "autocomplete", "off"]
var hoisted6 = ["class", "input-group-btn"]
var hoisted7 = ["class", "btn btn-primary btn-sm", "type", "submit"]
var hoisted8 = ["class", "btn btn-secondary btn-sm", "type", "button"]
var hoisted9 = ["class", "form-group"]
var hoisted10 = ["for", "name"]
var hoisted11 = ["class", "input-group"]
var hoisted12 = ["type", "text", "class", "form-control input-sm", "id", "dirname", "autocomplete", "off"]
var hoisted13 = ["class", "input-group-btn"]
var hoisted14 = ["class", "btn btn-primary btn-sm", "type", "submit"]
var hoisted15 = ["class", "btn btn-secondary btn-sm", "type", "button"]
var hoisted16 = ["class", "form-group"]
var hoisted17 = ["for", "name"]
var hoisted18 = ["class", "input-group"]
var hoisted19 = ["type", "text", "class", "form-control input-sm", "id", "rename", "autocomplete", "off"]
var hoisted20 = ["class", "input-group-btn"]
var hoisted21 = ["class", "btn btn-primary btn-sm", "type", "submit"]
var hoisted22 = ["class", "btn btn-secondary btn-sm", "type", "button"]
var __target

module.exports = function fileEditor (model, hide) {
  var file = model.file
  if (file) {
    elementOpen("div", "d05631d1-1c85-460c-85da-c65f3b1426d4", hoisted1)
      if (model.mode === 'mkfile') {
        elementOpen("form", "mkfile", null, "onsubmit", function ($event) {
          var $element = this;
        model.mkfile($event)})
          elementOpen("div", "df8e93f8-c024-4f5f-b90d-57f28f229cb3", hoisted2)
            elementOpen("label", "44591a24-a61a-46f2-a6d4-662bcca2516b", hoisted3)
              text("Add new file")
            elementClose("label")
            elementOpen("div", "bcd47b9a-bf80-4879-9798-561682a600cd", hoisted4)
              elementOpen("input", "89405972-5440-40f9-b6b7-dd0210a7f2c8", hoisted5)
              elementClose("input")
              elementOpen("span", "ed2bbfef-a7cb-4e92-82a2-cd5b1938cba4", hoisted6)
                elementOpen("button", "85f0e48d-daee-4c32-8ce1-878f2b0d7fd1", hoisted7)
                  text("OK")
                elementClose("button")
                elementOpen("button", "4aa134d6-1101-4269-9b28-6dbe5fe2ab74", hoisted8, "onclick", function ($event) {
                  var $element = this;
                hide()})
                  text("Cancel")
                elementClose("button")
              elementClose("span")
            elementClose("div")
          elementClose("div")
        elementClose("form")
      }
      if (model.mode === 'mkdir') {
        elementOpen("form", "mkdir", null, "onsubmit", function ($event) {
          var $element = this;
        model.mkdir($event)})
          elementOpen("div", "54dfc1e3-229c-46ea-bedc-665a4c876520", hoisted9)
            elementOpen("label", "fac2f4d6-3bea-4db8-8702-9767db02a110", hoisted10)
              text("Add new folder")
            elementClose("label")
            elementOpen("div", "2b96170b-b1bc-4dd2-b0ca-88104ff41491", hoisted11)
              elementOpen("input", "537299ed-45ad-4265-ab4c-2fdbbf3b3fb4", hoisted12, "value", file.getRelativePath() ? file.getRelativePath() + '/' : '')
              elementClose("input")
              elementOpen("span", "ea600567-1038-4848-aa69-0d60315ea967", hoisted13)
                elementOpen("button", "cc05a28d-434a-4e97-aba4-edf315b0d76a", hoisted14)
                  text("OK")
                elementClose("button")
                elementOpen("button", "b9891e14-f1c7-4bcc-8a85-c4fcc7e9ad3d", hoisted15, "onclick", function ($event) {
                  var $element = this;
                hide()})
                  text("Cancel")
                elementClose("button")
              elementClose("span")
            elementClose("div")
          elementClose("div")
        elementClose("form")
      }
      if (model.mode === 'rename') {
        elementOpen("form", "rename", null, "onsubmit", function ($event) {
          var $element = this;
        model.rename($event, file)})
          elementOpen("div", "20ae8637-960a-47de-baff-3fb5cb801f52", hoisted16)
            elementOpen("label", "eddc6fca-a53d-43f7-a061-f7a77386e6b5", hoisted17)
              text("Rename")
            elementClose("label")
            elementOpen("div", "4a2763c2-024d-4aa3-bb2c-0c17cd7fadd0", hoisted18)
              elementOpen("input", "24299ff2-6c44-430b-b7c2-d92e810f99ec", hoisted19, "value", file.name)
              elementClose("input")
              elementOpen("span", "c3445517-1657-44bf-a62a-4a7ca99c8d75", hoisted20)
                elementOpen("button", "42c02e4e-6303-4e5d-8162-9e2112fffd20", hoisted21)
                  text("OK")
                elementClose("button")
                elementOpen("button", "ff7ea3c5-9b66-47f2-8a0e-f14ce219979a", hoisted22, "onclick", function ($event) {
                  var $element = this;
                hide()})
                  text("Cancel")
                elementClose("button")
              elementClose("span")
            elementClose("div")
          elementClose("div")
        elementClose("form")
      }
    elementClose("div")
  }
}
